import React from 'react';
import { Button as LinkButton, Tooltip } from 'antd';

const Tip = (props) => (
  <Tooltip
    placement="right"
    title={props.title}
    overlayClassName="col-title-tip"
  >
    <span
      className="appkiticon icon-information-fill "
      style={{ marginLeft: '0.313rem' }}
    />
  </Tooltip>
);
const renderLinkButton = (
  <div>
    iFrame allows you to embed other webpages, documents, and other forms of
    multimedia without leaving the page. Please refer to the iFrame
    configuration{' '}
    <a
      target="_blank"
      href="/gateway/guide-shared"
      style={{ padding: 0, fontSize: '1rem' }}
    >
      <span style={{ textDecoration: 'underline' }}>here</span>
    </a>{' '}
    for additional instructions for PowerBI and Tableau.
  </div>
);
export const FORM_KEYS = {
  MODULE: {
    label: 'Modules',
    key: 'module',
    placeholder: 'Please enter the tile name',
  },
  DISPLAY: {
    // label: 'Display?',
    key: 'display',
  },
  TYPE: {
    label: 'Type',
    key: 'type',
  },
  IFRAME: {
    label: (
      <>
        iFrame
        <Tip title={renderLinkButton} />
      </>
    ),
    key: 'iframe',
  },
  ICON: {
    label: 'Icon',
    key: 'icon',
  },
  LINK: {
    label: 'Link',
    key: 'link',
    placeholder: 'Please enter the link here',
  },
  MSECTION: {
    label: 'Main Section',
    key: 'mainSection',
    // placeholder: 'Please enter the link here',
  },
  SECTION_LIST: {
    label: 'Main Section',
    key: 'originPermissions',
  },
  INTERNAL: {
    label: 'All PwC',
    key: 'internalPermissions',
  },
  CLIENT: {
    label: 'All Clients',
    key: 'clientPermissions',
  },

  DELETE: {
    key: 'id',
  },

  DRAG: {
    key: 'drag',
  },
  DLINK: {
    label: 'Link',
    key: 'defalut_link',
    placeholder: 'Not Applicable',
  },
  RATIO: {
    label: 'Report Ratio',
    key: 'ratio',
  },
  GROUP: {
    key: 'groupPermissions',
  },
};
